'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct17 from "./scala.-Product17.js";
var $p;
/** @constructor */
function $c_T17(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17) {
  this.nR = null;
  this.o0 = null;
  this.o1 = null;
  this.o2 = null;
  this.o3 = null;
  this.o4 = null;
  this.o5 = null;
  this.o6 = null;
  this.o7 = null;
  this.nS = null;
  this.nT = null;
  this.nU = null;
  this.nV = null;
  this.nW = null;
  this.nX = null;
  this.nY = null;
  this.nZ = null;
  this.nR = _1;
  this.o0 = _2;
  this.o1 = _3;
  this.o2 = _4;
  this.o3 = _5;
  this.o4 = _6;
  this.o5 = _7;
  this.o6 = _8;
  this.o7 = _9;
  this.nS = _10;
  this.nT = _11;
  this.nU = _12;
  this.nV = _13;
  this.nW = _14;
  this.nX = _15;
  this.nY = _16;
  this.nZ = _17;
}
export { $c_T17 as $c_T17 };
$p = $c_T17.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T17;
/** @constructor */
function $h_T17() {
}
export { $h_T17 as $h_T17 };
$h_T17.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 17;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct17.$f_s_Product17__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-934366247), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T17) && (((((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nR, x$0.nR) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o0, x$0.o0)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o1, x$0.o1)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o2, x$0.o2)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o3, x$0.o3)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o4, x$0.o4)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o5, x$0.o5)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o6, x$0.o6)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.o7, x$0.o7)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nS, x$0.nS)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nT, x$0.nT)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nU, x$0.nU)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nV, x$0.nV)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nW, x$0.nW)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nX, x$0.nX)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nY, x$0.nY)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nZ, x$0.nZ))));
});
$p.o = (function() {
  return "Tuple17";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((((((((("(" + this.nR) + ",") + this.o0) + ",") + this.o1) + ",") + this.o2) + ",") + this.o3) + ",") + this.o4) + ",") + this.o5) + ",") + this.o6) + ",") + this.o7) + ",") + this.nS) + ",") + this.nT) + ",") + this.nU) + ",") + this.nV) + ",") + this.nW) + ",") + this.nX) + ",") + this.nY) + ",") + this.nZ) + ")");
});
function $isArrayOf_T17(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eG)));
}
export { $isArrayOf_T17 as $isArrayOf_T17 };
var $d_T17 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T17, "scala.Tuple17", ({
  eG: 1,
  b: 1,
  c: 1,
  rP: 1,
  a: 1
}));
export { $d_T17 as $d_T17 };
